import styled, { css } from "styled-components";

export const Title = styled.h3`
    font: 700 22px "Playfair Display";
    line-height: 36px;
    padding: 0px 0 26px;
    margin: 0 20px;
    ${(props) =>
        props.withBorder &&
        css`
            border-bottom: 1px solid #ccc;
        `}
`;

export const MultiInputWrapper = styled.div`
    &&& {
        .single-choice-container {
            min-height: unset;
            display: unset;
        }

        .question {
            margin: 20px 0 16px 0;
        }
    }
`;
